// src/components/ExportPNG.jsx
import React from 'react';
import { useReactFlow, getNodesBounds } from '@xyflow/react';
import { toPng } from 'html-to-image';

function downloadImage(dataUrl, isAltPressed = false) {
  const a = document.createElement('a');
  a.setAttribute('download', isAltPressed ? 'reactflow-rgba.png' : 'reactflow-rgb.png');
  a.setAttribute('href', dataUrl);
  a.click();
}


const IMAGE_PADDING = 40;

const ExportPNG = ({ className, canvasColor }) => { // Removed bgAlpha from props
  const { getNodes } = useReactFlow(); // `project` wasn't used, so removed for now

  // The onClick handler automatically receives the event object
  const onClick = (event) => {
    const isAltPressed = event.altKey; // Check if Alt key was pressed during this click

    const nodes = getNodes();
    if (nodes.length === 0) {
      alert("No nodes to export.");
      return;
    }

    const nodesBounds = getNodesBounds(nodes);

    const imageWidth = Math.round(nodesBounds.width + 2 * IMAGE_PADDING);
    const imageHeight = Math.round(nodesBounds.height + 2 * IMAGE_PADDING);

    const transformX = -nodesBounds.x + IMAGE_PADDING;
    const transformY = -nodesBounds.y + IMAGE_PADDING;
    const transformZoom = 1;

    const viewportElement = document.querySelector('.react-flow__viewport');
    if (!viewportElement) {
      console.error('React Flow viewport element not found.');
      alert('Error: Could not find the flow viewport to capture.');
      return;
    }

    toPng(viewportElement, {
      // Use isAltPressed to determine the background
      backgroundColor: isAltPressed ? 'transparent' : canvasColor || '#0a1120',
      width: imageWidth,
      height: imageHeight,
      style: {
        width: `${imageWidth}px`,
        height: `${imageHeight}px`,
        transform: `translate(${transformX}px, ${transformY}px) scale(${transformZoom})`,
      },
      // pixelRatio: window.devicePixelRatio > 1 ? 2 : 1, // Optional for higher res
    })
    // CORRECTED .then() usage:
    .then((dataUrl) => {
      downloadImage(dataUrl, isAltPressed);
    })
    .catch((error) => {
      console.error('Image export failed:', error);
      alert(`Image export failed: ${error.message}`);
    });
  };

  return (
    <button
      className={className || "download-btn xy-theme__button"}
      onClick={onClick} // The event object will be passed here
      title="Export PNG (Alt/Option + Click for Transparent Background)"
    >
      PNG
    </button>
  );
};

export default ExportPNG;



// // src/components/ExportPNG.jsx
// import React from 'react';
// import { useReactFlow, getNodesBounds } from '@xyflow/react'; // getViewportForBounds is not strictly needed if we scale to 1 and translate
// import { toPng } from 'html-to-image';

// function downloadImage(dataUrl) {
//   const a = document.createElement('a');
//   a.setAttribute('download', 'reactflow.png');
//   a.setAttribute('href', dataUrl);
//   a.click();
// }

// // Define a padding value for the image
// const IMAGE_PADDING = 40; // e.g., 40 pixels padding on all sides

// const ExportPNG = ({ className, canvasColor, bgAlpha }) => {
//   const { getNodes, project } = useReactFlow(); // project can convert screen to flow coords

//   const onClick = () => {
//     const nodes = getNodes();
//     if (nodes.length === 0) {
//       alert("No nodes to export."); // Or handle this more gracefully
//       return;
//     }

//     const nodesBounds = getNodesBounds(nodes);

//     // Calculate image dimensions based on node bounds plus padding
//     const imageWidth = Math.round(nodesBounds.width + 2 * IMAGE_PADDING);
//     const imageHeight = Math.round(nodesBounds.height + 2 * IMAGE_PADDING);

//     // Calculate the transform to position the nodes correctly within the image
//     // We want the top-left of the nodesBounds (minus padding) to be at (0,0) of the image
//     // And we want the scale to be 1 (natural size)
//     const transformX = -nodesBounds.x + IMAGE_PADDING;
//     const transformY = -nodesBounds.y + IMAGE_PADDING;
//     const transformZoom = 1; // We want the nodes at their actual size

//     // Get the viewport element
//     const viewportElement = document.querySelector('.react-flow__viewport');
//     if (!viewportElement) {
//         console.error('React Flow viewport element not found.');
//         alert('Error: Could not find the flow viewport to capture.');
//         return;
//     }

//     toPng(viewportElement, {
//       backgroundColor: bgAlpha ? 'transparent' : canvasColor || '#0a1120',

//       width: imageWidth,
//       height: imageHeight,
//       style: {
//         width: `${imageWidth}px`, // Important to pass as string with 'px'
//         height: `${imageHeight}px`,// Important to pass as string with 'px'
//         transform: `translate(${transformX}px, ${transformY}px) scale(${transformZoom})`,
//       },
//       // You might want to adjust pixelRatio for higher resolution, but it can affect performance
//       // pixelRatio: window.devicePixelRatio > 1 ? 2 : 1, // Example: for retina displays
//     })
//     .then(downloadImage)
//     .catch((error) => {
//       console.error('Image export failed:', error);
//       alert(`Image export failed: ${error.message}`);
//     });
//   };

//   return (
//     <button
//       className={className || "download-btn xy-theme__button"}
//       onClick={onClick}
//       title="Export PNG | + Alt/Option Transparency"
//     >
//       PNG
//     </button>
//   );
// };

// export default ExportPNG;